import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import { BokkzIbDataService, Aangifte, BokkzAlgDataService } from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-wuo-adminKoppelen',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-wuo-adminKoppelen.component.html',
    styleUrl: './tekst-wuo-adminKoppelen.component.scss',
})
export class TekstWuoAdminKoppelenComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    constructor(
        public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
        })
    }

}
